
import { hasRoles, isAuthenticated } from '@/utils/auth';
import { createRouter, createWebHistory } from 'vue-router';
const HomePage = () => import('@/screens/DashboardPage.vue');
const NotFound = () => import('@/screens/NotFound.vue');
const ForbiddenPage = () => import('@/screens/ForbiddenPage.vue');
const LoginPage = () => import('@/screens/LoginPage.vue');
const LandingPage = ()=> import('@/screens/LandingPage.vue');
const routes = [
    {
        path: '/',
        name: 'home',
        component: LandingPage,
        meta: { requiresAuth: false}
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: HomePage,
        meta: { requiresAuth: true, showHeader: true, roles: ['san', 'bplo', 'mpdc', 'treasury', 'obo', 'admin', 'it'] }
    },
    

    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        // meta: { requiresAuth: true, showHeader: true, roles: roles.adminDashboardRoles }
    },
    {
        path: '/forbidden',
        name: 'forbidden',
        component: ForbiddenPage,
    },
    { path: '/:catchAll(.*)', component: NotFound, meta: { showHeader: false } }
]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { el: to.hash };
        }
        return savedPosition || { top: 0 };
    }
});
router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'BPLS System'; // Fallback if no title
    const isAuthed = isAuthenticated(); // Implement your authentication check
    // Redirect to login if route requires auth and user is not authenticated
    if (to.meta.requiresAuth && !isAuthed) {
        return next({ name: 'login', query: { redirect: to.fullPath } })
    }

    // Redirect away from auth pages if already logged in
    if (to.meta.requiresGuest && isAuthed) {
        return next({ name: 'dashboard' })
    }

    if (to.path === '/login' && isAuthed)
        return next({ name: 'dashboard' });

    // Handle role-based access control
    if (to.meta.roles && to.meta.roles.length > 0) {
        const hasAccess = hasRoles(to.meta.roles); // Example function to get user roles
        // Check if any of the user's roles match the allowed roles

        if (!hasAccess) {
            // Redirect to unauthorized page or handle unauthorized access
            return next('/forbidden'); // Example redirect to unauthorized page
        }
    }

    next()
})



export default router;
